import {createReducer, on} from "@ngrx/store"
import {
  AddReports,
  ClearState,
  DownloadReportFailure,
  DownloadReportRequest,
  DownloadReportSuccess,
  FetchBehaviorTypeOptionsListFailure,
  FetchBehaviorTypeOptionsListRequest,
  FetchBehaviorTypeOptionsListSuccess,
  FetchClinicsOptionsListFailure,
  FetchClinicsOptionsListRequest,
  FetchClinicsOptionsListSuccess,
  FetchGeneratedReportsListFailure,
  FetchGeneratedReportsListRequest,
  FetchGeneratedReportsListSuccess,
  FetchGroupsOptionsListFailure,
  FetchGroupsOptionsListRequest,
  FetchGroupsOptionsListSuccess,
  FetchParticipantOptionsListFailure,
  FetchParticipantOptionsListRequest,
  FetchParticipantOptionsListSuccess, FetchQuestionnaireOptionsListFailure,
  FetchQuestionnaireOptionsListRequest,
  FetchQuestionnaireOptionsListSuccess,
  FetchReportsOptionsFailure,
  FetchReportsOptionsRequest,
  FetchReportsOptionsSuccess,
  RegenerateReportFailure,
  RegenerateReportRequest,
  RegenerateReportSuccess,
  UpdateReportStatus,
  StartReportPolling,
  StopReportPolling
} from "./reports.actions";
import {DropdownOption} from "../../../../models/dropdown-option.model";
import {Report} from "../model/reports.model";

export interface ReportsState {
  dummy: boolean,
  reportOptions: {
    list?: DropdownOption[],
    total?: number,
    pageNumber?: number,
    limit?: number,
    hasNext?: boolean,
    hasPrev?: boolean
    loading?: boolean
  },
  reportList:{
    list?: DropdownOption[],
    total?: number,
    pageNumber?: number,
    limit?: number,
    hasNext?: boolean,
    hasPrev?: boolean
    loading?: boolean
  },
  clinic: {
    list?: DropdownOption[],
    total?: number,
    pageNumber?: number,
    limit?: number,
    hasNext?: boolean,
    hasPrev?: boolean
    loading?: boolean
  },
  group: {
    list?: DropdownOption[],
    total?: number,
    pageNumber?: number,
    limit?: number,
    hasNext?: boolean,
    hasPrev?: boolean
    loading?: boolean
  },
  behaviorType: {
    list: DropdownOption[],
    loading: boolean
  },
  participant: {
    list?: DropdownOption[],
    total?: number,
    pageNumber?: number,
    limit?: number,
    hasNext?: boolean,
    hasPrev?: boolean
    loading?: boolean
  },
  questionnaire: {
    list?: DropdownOption[],
    total?: number,
    pageNumber?: number,
    limit?: number,
    hasNext?: boolean,
    hasPrev?: boolean
    loading?: boolean
  },
  reports: {
    loading: boolean,
    list: Report[],
    hasNext: boolean,
    hasPrev: boolean,
    total: number,
    limit: number
  },
  pollingReports: {
    [reportId: number]: boolean
  }
}

const initialState: ReportsState = {
  dummy: false,
  reportList:{
    list: [],
    hasNext: false,
    hasPrev: false,
    limit: 0,
    pageNumber: 0,
    total: 0,
    loading: false
  },
  reportOptions: {
    list: [],
    hasNext: false,
    hasPrev: false,
    limit: 0,
    pageNumber: 0,
    total: 0,
    loading: false
  },
  clinic: {
    list: [],
    hasNext: false,
    hasPrev: false,
    limit: 0,
    pageNumber: 0,
    total: 0,
    loading: false
  },
  group: {
    list: [],
    hasNext: false,
    hasPrev: false,
    limit: 0,
    pageNumber: 0,
    total: 0,
    loading: false
  },
  behaviorType: {
    list: [],
    loading: false
  },
  participant: {
    list: [],
    hasNext: false,
    hasPrev: false,
    limit: 0,
    pageNumber: 0,
    total: 0,
    loading: false
  },
  questionnaire: {
    list: [],
    hasNext: false,
    hasPrev: false,
    limit: 0,
    pageNumber: 0,
    total: 0,
    loading: false
  },
  reports: {
    loading: false,
    list: [],
    hasNext: false,
    hasPrev: false,
    limit: 0,
    total: 0
  },
  pollingReports: {}
}

export const reducer = createReducer(initialState,
  //reports options
  on(FetchReportsOptionsRequest, state => ({
    ...state, reportOptions: {
      ...state.reportOptions,
      loading: true,
    }
  })),

  on(FetchReportsOptionsSuccess, (state, props) => ({
    ...state, reportOptions: {
      ...props.payload,
      loading: false,
    }
  })),


  on(FetchReportsOptionsFailure, state => ({
    ...state, reportOptions: {
      ...state.reportOptions,
      loading: false,
    }
  })),

  //clinics options
  on(FetchClinicsOptionsListRequest, (state, props) => ({
    ...state, clinic: {
      ...state.clinic,
      loading: true,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? { list: [] } : {list: state.clinic.list} : []),
    }
  })),

  on(FetchClinicsOptionsListSuccess, (state, props) => {
    return ({
      ...state, clinic: {
        ...props.payload,
        loading: false,
        ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? {list: props.payload.list} : {
          list: [
            ...state.clinic.list, ...props.payload.list
          ]
        } : []),
      }
    })
  }),


  on(FetchClinicsOptionsListFailure, state => ({
    ...state, clinic: {
      list: [], loading: false
    }
  })),


  //group options
  on(FetchGroupsOptionsListRequest, (state,props) => ({
    ...state, group: {
      ...state.group,
      loading: true,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? { list: [] } : {list: state.group.list} : []),

    }
  })),

  on(FetchGroupsOptionsListSuccess, (state, props) => ({
    ...state, group: {
      ...props.payload,
      loading: false,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? {list: props.payload.list} : {
        list: [
          ...state.group.list, ...props.payload.list
        ]
      } : []),
    }
  })),


  on(FetchGroupsOptionsListFailure, state => ({
    ...state, group: {
      ...state.group,
      loading: false,
    }
  })),

  //behaviour options
  on(FetchBehaviorTypeOptionsListRequest, state => ({
    ...state, behaviorType: {
      list: [], loading: true
    }
  })),

  on(FetchBehaviorTypeOptionsListSuccess, (state, props) => ({
    ...state, behaviorType: {
      list: props.payload.list, loading: false
    }
  })),


  on(FetchBehaviorTypeOptionsListFailure, state => ({
    ...state, behaviorType: {
      list: [], loading: false
    }
  })),

  //participant options
  on(FetchParticipantOptionsListRequest, (state,props) => ({
    ...state, participant: {
      loading: true,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? { list: [] } : {list: state.participant.list} : []),
    }
  })),

  on(FetchParticipantOptionsListSuccess, (state, props) => ({
    ...state, participant: {
      ...props.payload,
      loading: false,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? {list: props.payload.list} : {
        list: [
          ...state.participant.list, ...props.payload.list
        ]
      } : []),
    }
  })),


  on(FetchParticipantOptionsListFailure, state => ({
    ...state, participant: {
      list: [], loading: false
    }
  })),

  // questionnaire options
  on(FetchQuestionnaireOptionsListRequest, (state, props) => ({
    ...state,
    questionnaire: {
      loading: true,
      list: [],
    }
  })),

  on(FetchQuestionnaireOptionsListSuccess, (state, props) => ({
    ...state,
    questionnaire: {
      ...props.payload,
      loading: false,
      list: props.data
    }
  })),


  on(FetchQuestionnaireOptionsListFailure, state => ({
    ...state,
    questionnaire: {
      list: [],
      loading: false
    }
  })),

  //add reports
  on(AddReports, (state, props) => ({
    ...state,
    reports: {
      ...state.reports,
      list: [...state.reports.list, {...props.payload.report}],
      loading: false,
    }
  })),

  //fetch generated reports

  on(FetchGeneratedReportsListRequest,(state,props)=>({
    ...state,
    reportList:{
      ...state.reportList,
      loading:true,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? { list: [] } : {list: state.reportList.list} : []),
    }
  })),

  on(FetchGeneratedReportsListSuccess,(state,props)=>({
    ...state,
    reportList:{
      loading:false,
      ...props.payload,
      ...(props.payload.pageNumber ? props.payload.pageNumber === 1 ? {list: props.payload.list} : {
        list: [
          ...state.reportList.list, ...props.payload.list
        ]
      } : []),
    }
  })),

  on(FetchGeneratedReportsListFailure,(state,props)=>({
    ...state,
    reportList:{
      ...state.reportList,
      loading:false
    }
  })),

  on(DownloadReportRequest,state=>state),

  on(DownloadReportSuccess,state=>state),

  on(DownloadReportFailure,state=>state),

  on(RegenerateReportRequest,state=>state),

  on(RegenerateReportSuccess,state=>state),

  on(RegenerateReportFailure,state=>state),

  // Start polling for a report
  on(StartReportPolling, (state, { reportId }) => ({
    ...state,
    pollingReports: {
      ...state.pollingReports,
      [reportId]: true
    }
  })),

  // Stop polling for a report
  on(StopReportPolling, (state, { reportId }) => {
    const { [reportId]: removed, ...remaining } = state.pollingReports;
    return {
      ...state,
      pollingReports: remaining
    };
  }),

  // Update report status during polling
  on(UpdateReportStatus, (state, { payload }) => {
    const updatedList = state.reportList.list.map((report: any) => {
      if (report.id === payload.reportId) {
        return {
          ...report,
          status: payload.status,
          error: payload.error
        };
      }
      return report;
    });

    // Check if status is final (2=AvailableForDownload, 3=Failed, 4=Downloaded) and remove from polling
    const isFinalStatus = payload.status?.key === 2 || payload.status?.key === 3 || payload.status?.key === 4;
    let updatedPollingReports = state.pollingReports;
    
    if (isFinalStatus && state.pollingReports[payload.reportId]) {
      const { [payload.reportId]: removed, ...remaining } = state.pollingReports;
      updatedPollingReports = remaining;
    }

    return {
      ...state,
      reportList: {
        ...state.reportList,
        list: updatedList
      },
      pollingReports: updatedPollingReports
    };
  }),

  on(ClearState, (state) => ({
    ...state, dummy: false
  })),
)
